import {HeaderSection} from "components/HeaderSection/HeaderSection";
import {useTranslation} from "react-i18next";
import s from "./Blog.module.scss";
import {Card} from "./Card/Card";
import {useEffect, useState} from "react";
import {useGetBlogsQuery} from "../../redux/apis/blogApi";
import {Preloader} from "components/Preloader/Preloader";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { TagsView } from "components/TagsView/TagsView";
import { Pagination } from "@mui/material";
const URL = process.env.REACT_APP_API_ADDRESS

export const Blog = () => {
    const [currentTag, setCurrentTag] = useState<any>([])
    const [query, setQuery] = useState({page: 1, limit: 20})
    const { t } = useTranslation();
    const navigate = useNavigate()
    const langs = useSelector((store: any) => store.main.langs)

    const {data: blogs, isFetching: isFetchingBlogs, refetch} = useGetBlogsQuery({tags: [currentTag], ...query});
    
    useEffect(() => {
        refetch()
    }, []);

    // ### Function
    function modifyImageData(image: any){
        return Object.entries(image)?.reduce((acc: any, el: any) => {
            if(el[0] === "default_image" || el[0] === "isManual"){
                acc[el[0]] = el[1]
            }else{
                acc[el[0]] = `${URL?.slice(0, -1)}${el[1]}`
            }
            return acc
        },{})
    }

    // ### Views

    const blogsView = blogs?.blogs?.map((blog: any, index: number) => {
        return(
            <Card 
                key={index}
                id={blog.id}
                image={modifyImageData(blog?.image)}
                title={blog.active_card_title ? blog?.card_title?.[langs?.[0]?.key] : blog?.title?.[langs?.[0]?.key]}
                body={blog.active_card_body ? blog?.card_body?.[langs?.[0]?.key] : blog?.body?.[langs?.[0]?.key]}
                author={blog.author}
            />
        )
    })

    return (
        <div className={s.wrap_blog}>
            <HeaderSection
                title={t("tabBar.blog")}
                buttonText={"Add blog"}
                onClick={() => navigate('/blog/create')}
            />
            <TagsView 
                type="blog"
                setCurrentTag={setCurrentTag}
            />
            <div className={s.list}>
                {blogsView}
            </div>
            { blogs?.totalPages > 1 ?
                <div className={s.pagination_wrapper}>
                    <Pagination 
                        count={blogs?.totalPages} 
                        variant="outlined" 
                        shape="rounded"
                        page={query.page}
                        onChange={((_, page) => setQuery(prev => ({...prev, page})))}
                    />
                </div> : null
            }
            {isFetchingBlogs && <Preloader />}
        </div>
    )
}